import ViewActTeam from './ViewActTeam';

export default ViewActTeam;
